import { render, staticRenderFns } from "./depot.vue?vue&type=template&id=1b05745f&"
import script from "./depot.vue?vue&type=script&lang=js&"
export * from "./depot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports